<template>
    <div class="row" v-if="counters">
        <rd-column :size="$columns.FourOnLg" class="mobile-column">
            <rd-card type="vertical">
                <rd-card-header center-content="true">
                    <rd-header :title="`${counters.AcceptedCount}`" margins="none" size="large" />
                </rd-card-header>
                <rd-card-content>
                    <rd-header center-content="true"
                               :title="$t('dashboard.counters.accepted')"
                               size="small"
                               margins="none"
                               type="secondary" />
                </rd-card-content>
            </rd-card>
        </rd-column>
        <rd-column :size="$columns.FourOnLg" class="mobile-column">
            <rd-card type="vertical">
                <rd-card-header center-content="true">
                    <rd-header :title="`${counters.DeclinedCount}`" margins="none" size="large" />
                </rd-card-header>
                <rd-card-content>
                    <rd-header center-content="true"
                               :title="$t('dashboard.counters.rejected')"
                               size="small"
                               margins="none"
                               type="secondary" />
                </rd-card-content>
            </rd-card>
        </rd-column>
        <rd-column :size="$columns.FourOnLg" class="mobile-column">
            <rd-card type="vertical">
                <rd-card-header center-content="true">
                    <rd-header :title="`${counters.ReceivedCount}`" margins="none" size="large" />
                </rd-card-header>
                <rd-card-content>
                    <rd-header center-content="true"
                               :title="$t('dashboard.counters.delivered')"
                               size="small"
                               margins="none"
                               type="secondary" />
                </rd-card-content>
            </rd-card>
        </rd-column>
    </div>
</template>

<script>
    // @ is an alias to /src
    //import Axios from 'axios';
    //import router from 'vue-router';
    //import sideNav from '../components/sideNav/Index'
    import { mapFields } from 'vuex-map-fields';
    import { mapState, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboard',
        created() {
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapState(name, ['counters'])
        },
        methods: {
            ...mapActions(name, ['setCounters'])
        },
        mounted() {
            this.setCounters();
        },
        components: {
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
<style scoped lang="scss">
    @media (min-width: 765px) and (max-width: 980px) {
    .mobile-column {
        flex-basis: 25% !important;
    }
}
</style>